export default function renderAdrTaEquipmentV3(data) {
  return function (pdf) {};
}
